export default function Company() {
  return (
    <section id="company" className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[180px] font-bold text-white whitespace-nowrap">
          HORAL
        </div>
      </div>

      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-5xl font-bold text-white mb-8">
          About HORAL d.o.o.
        </h2>
        
        <div className="space-y-6 text-lg text-gray-300 leading-relaxed">
          <p>
            HORAL d.o.o. is a technology company dedicated to developing innovative applications that enhance digital security and user experience. Based in Zadar, Croatia, we specialize in creating cutting-edge solutions that protect user privacy and simplify digital life.
          </p>
          
          <p>
            Our flagship product, HORAL VPN, represents our commitment to providing users with the highest level of online security and freedom. We believe that everyone deserves access to a free and open internet without compromising their privacy. Through continuous innovation and dedication to excellence, we strive to deliver products that our users can trust and rely on every day.
          </p>
        </div>

        <div className="mt-12 pt-12 border-t border-gray-700">
          <div className="flex items-center justify-center space-x-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/fdef5987-68a4-4db5-abaa-06ff7eec96d2.png" 
              alt="HORAL Logo" 
              className="h-12 w-auto"
            />
          </div>
          <p className="text-gray-400 mt-4 text-lg">
            Protecting Your Privacy, Empowering Your Freedom
          </p>
        </div>
      </div>
    </section>
  );
}
